import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {selectAuthState} from '../../../store/app.states';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {DoctorService} from '../../../services/doctor.service';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../model/user/Patient';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {ChatMessage} from '../../../model/chat-message/ChatMessage';
import {AuthService} from "../../../services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ToolbarService} from "../../../services/toolbar.service";
import { Plugins, AppState } from '@capacitor/core';
const { App } = Plugins;
import { Platform } from '@ionic/angular';
import {AttachFileDialogComponent} from "../../../services/dialogs/attach-file-dialog/attach-file-dialog.component";


@Component({
  selector: 'app-doctor-chat',
  templateUrl: './doctor-chat.component.html',
  styleUrls: ['./doctor-chat.component.css']
})
export class DoctorChatComponent implements OnDestroy, OnInit {

  getAuthState: Observable<any>;
  customState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  message;
  title = 'Chat';
  back = true;
  destination = '/landing';
  lastMessages: ChatMessage[]; // = ELEMENT_DATA;
  messages: any[];
  textSend = '';
  @ViewChild('scrollMe') myScrollContainer: ElementRef; // importato abbassare la scroll bar.
  patients: Patient[] = [];
  filteredOptions: Observable<Patient[]>;
  myControl = new FormControl();
  patientChat: Patient;
  // i tre campi qui sotto vengono utilizzati per riconoscere un dispositivo mobile
  isMobile: boolean;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  private subscripitons: Subscription[] = [];
  img: string;


  constructor(private store: Store<AppState>,
              private dialog: MatDialog,
              private router: Router,
              private route: ActivatedRoute,
              private doctorService: DoctorService,
              private authService: AuthService,
              private snackBar: MatSnackBar,
              private toolbarService: ToolbarService,
              private platform: Platform,
              /*private state: AppState*/) {
    this.getAuthState = this.store.select(selectAuthState);
    this.subscripitons.push(this.route.params.subscribe( params => {
      if (params.back === undefined){
        this.destination = 'landing';
      } else if (params.back.localeCompare('general-status') === 0) {
        this.destination = 'general-status';
      } else {
        this.destination = 'landing';
      }
    }));
  }

  ngOnInit(): void {
    // iniziamo a controllare se lo schermo è di un dispositivo mobile.
    // il codice è stato copiato da ciò che era già presente in toolbarComponent
    this.subscribeResizeChanges()

    // Ogni volta che si riceve una notifica dal server dell'arrivo di un nuovo messaggio
    // viene scatenato questa lambda function
    document.addEventListener('new-chat-message', () => {
      console.log('newMessage')
      this.refreshChat();
    });

    /*document.addEventListener('appStateChange', () => {
      if (this.state.isActive) {
        console.log('App has become active');
        this.refreshChat();
      }
    });*/
    this.subscribeAppStateChange();



    // La seguente istruzione è utile per filtrare i pazienti durante la ricerca nel
    // campo input, che permette di iniziare una nuova chat.
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value.toString()))
      );

    this.subscripitons.push(this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;

      this.getLastMessages().subscribe(lm => this.lastMessages = lm);

      // mi salvo tutti i pazienti globali per poi ricercarli nel campo input sopra citato.
      this.doctorService.getGlobalPatients().subscribe((patients) => {
        localStorage.setItem('patients', JSON.stringify(patients));
        this.patients = patients;

        // Dopo aver ottenuto i pazienti controllo se il codice fiscale presente nell'url
        // (se c'è) è presente tra i pazienti. Se lo troviamo apriamo subito la chat.
        this.subscripitons.push(this.route.params.subscribe(params => {
          // const component = window.location.href.split('/')[3];
          // controllo se mi trovo ancora in doctor-chat perché altrimenti questa subscribe
          // si può attivare anche in altri componenti.
          // if(component === 'doctor-chat') {
          console.log('sub params');
            const patientSSN = params.patientSSN;
            if (patientSSN !== undefined) {
              const patientChat = this.patients.find(p => p.ssn === patientSSN);
              // this.patientChat = patientChat;
              this.getChatMessages(patientChat);
            } else {
              this.patientChat = undefined;
            }
          // }
        }));
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('sessione scaduta');
          location.reload();
        }
      });
    }));

    /* nel caso l'utente non abbia attivato le notifiche forziamo il sistema a chiedere
       di aggiornare la chat ogni minuto */
    var firebaseToken = localStorage.getItem('firebase-token');
    console.log(firebaseToken)
    if(firebaseToken === 'null') {
      console.log('firebase-token non attivo');                             // 60 secondi
      setInterval(() => {console.log('controllo chat'); this.refreshChat(); }, 60000);
    }
  }

  // Questo metodo permette di controllare se il messaggio da visualizzare è mio (quindi va a destra)
  // oppure è di qualcun'altro (e quindi viene posizionato a sinistra)
  itIsMy(mess: any) {
    const mitt = mess.sender;
    if (mitt === this.user.email) {
      return true;
    } else {
      return false;
    }
  }


  sendMessage() {
    let textToSend = this.textSend;
    this.textSend = '';
    this.subscripitons.push(this.doctorService.sendMessage(textToSend, this.patientChat.email).subscribe(newMessage => {
      // l'end point contattato mi restituisce il dto con tutte le informazioni sul messaggio, lo parsifico
      const newMessageParsed = JSON.parse(newMessage.body);
      // Aggiungo il messaggio tra quelli della finestra e pulisco il campo dove ho scritto il messaggio.
      this.messages.push(newMessageParsed);
      //this.textSend = '';
      this.scrollToBottom();

      // Per aggiungere il nuovo messaggio nella barra di sinistra con gli ultimi messaggi,
      // cancello il precedente ultimo messaggio della chat con questo paziente e poi...
      this.lastMessages = this.lastMessages.filter( m => {
        if (m.patientEmail === this.patientChat.email) {
          return false;
        }
        return true;
      });
      /* modifico un altra variabile perché altrimenti il troncamento dopo 35 caratteri
         cancellerebbe anche il testo nel messaggio già aggiunt tra i this.messages*/
      let newMessageForLastMessages = JSON.parse(newMessage.body);
      // .... lo riaggiungo. Dopo averlo riaggiunto con il metodo splice, l'elenco viene aggiornato.
      if (newMessageParsed.text.length > 38) {
        newMessageForLastMessages.text = newMessageParsed.text.substr(0, 35) + ' [...]';
      }
      this.lastMessages.splice(0, 0, newMessageForLastMessages);
    }, error => {
      if (error.status === 500) {
        // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
        localStorage.setItem('expirationTime', '0');
        console.log('sessione scaduta');
        location.reload();
      }
      // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
    }));
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollToBottom(); // = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  /* Questo metodo viene scatenato quando si clicca su un paziente nei suggerimenti che
     vengono fuori dal campo input (quello per l'inizio di una nuova chat) */
  getOptionStudent(patientEmail: string) {
    const patientChat = this.patients.find(p => p.email === patientEmail);
    //Se diverso da undefined, l'utente è nel sistema e posso chiedere i messaggi
    //Se Uguale a undefined, l'utente non è nel sistema. non visualizzo i messaggi ma un popup
    if(patientChat!==undefined)
    // Chiedo al server l'elenco dei messaggi già scambiati
    this.getChatMessages(patientChat);
    else
    //lancio popup 'utente non nel sistema'
    this.openErrorDialog("L'utente con email "+patientEmail+" non è presente nel sistema.");
  }

  displayFn(patient: Patient): string {
    return patient && patient.name ? patient.name + ' ' + patient.surname + ' (' + patient.ssn + ')' : '';
  }

  /** Metodo che permette il filtro sul nome e cognome */
  private _filter(value: string): Patient[] {
    let filterValues: string[];
    const filterValue = value.toLowerCase();
    filterValues = filterValue.split(' ');

    if (filterValues.length === 1) {
      // tslint:disable-next-line:max-line-length
      return this.patients.filter(option => (option.name).toLowerCase().includes(filterValues[0]) || option.surname.toLowerCase().includes(filterValues[0]));
    }
    if (filterValues.length === 2) {
      // tslint:disable-next-line:max-line-length
      return this.patients.filter(option => ((option.name).toLowerCase().includes(filterValues[1]) && option.surname.toLowerCase().includes(filterValues[0]))
        || ((option.surname).toLowerCase().includes(filterValues[1]) && option.name.toLowerCase().includes(filterValues[0])));
    }
  }

  openPanel() {
    // la parte finale dell'url indica dove siamo partiti così se uno clicca la freccia per tornare
    // indietro, torna nella pagina della chat. È stato aggiunto anche nel patientPanelComponent
      this.router.navigateByUrl('/patient-panel/' + this.patientChat.ssn + '/doctor-chat');
  }

  /* Questo metodo aggiorna la barra laterale, e quindi l'elenco degli ultimi messaggi ricevuti/inviati
     e restituisce un observable con i messaggi */
  getLastMessages() {
    var lastMessagesObs = new Observable<ChatMessage[]>((observer) => {
      this.subscripitons.push(this.doctorService.getLastMessages().subscribe((lastMessages) => {
        lastMessages = lastMessages.map(mess => {
          if (mess.text.length > 38) {
            mess.text = mess.text.substr(0, 35) + ' [...]';
          }
          return mess;
        }).sort((a: ChatMessage, b: ChatMessage) => {
          return +new Date(b.date) - +new Date(a.date);
        });
        // scateniamo la subscribe del metodo che aspettava i lastMessages.
        observer.next(lastMessages);
        observer.complete();
      }, err => {
        if (err.status === 500) {
          // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
          localStorage.setItem('expirationTime', '0');
          console.log('sessione scaduta');
          location.reload();
        }
      }));
    });
    return lastMessagesObs;
  }

  // Questo metodo fa la richiesta al server della chat.
  getChatMessages(patient: Patient) {
    this.patientChat = patient;
    if (this.destination === 'general-status') {
      this.router.navigateByUrl('/doctor-chat/' + this.patientChat.ssn + '/general-status');
    } else {
      this.router.navigateByUrl('/doctor-chat/' + this.patientChat.ssn);
    }
    this.subscripitons.push(this.doctorService.getChatMessages(this.patientChat.email).subscribe(messages => {
      this.messages = messages;
      this.lastMessages.map(m => { // ho letto il messaggio quindi setto read a true.
        if (m.patientEmail === this.patientChat.email) {
          if (m.read === false && m.sender === m.patientEmail) {
            m.read = true;
          }
        }
      });

      // aspetto mezzo secondo prima di chiamare il metodo, altrimenti la pagina non è ancora stata caricata.
      setTimeout(this.scrollToBottom, 500);

      var messagesUnread = false; // inizio pensando che tutti i messaggi siano stati letti
      this.lastMessages.forEach(m => {
         if (m.read === false && m.sender === m.patientEmail) {
            messagesUnread=true; // trovato un messaggio non letto
         }
      });
      this.toolbarService.updateMessageUnreadBadge(messagesUnread);

    }, error => {
      if (error.status === 500) {
        // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
        localStorage.setItem('expirationTime', '0');
        console.log('sessione scaduta');
        location.reload();
      }
      //this.openErrorDialog('Qualcosa è andato storto. Se l\'errore persiste ci contatti via e-mail.');
    }));
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // Questo metodo aggiorna i messaggi in tutta la pagina (sia parte sinistra, che destra se presente)
  refreshChat(){
    // Aggiorno i LastMessages a sinistra.
    this.subscripitons.push(this.getLastMessages().subscribe(lastMessages => {
      this.lastMessages = [...lastMessages];
      this.lastMessages = lastMessages;
     //  this.reloadLastMessagesDiv();
      // console.log(lastMessages);
      /* Dall'url ottengo il paziente di cui abbiamo la chat aperta (se ce n'è uno). Così
      *  nel caso il messaggio arrivato sia indirizzato a lui aggiorniamo l'intera chat.
      *  Attenzione inizialmente si voleva usare la variabile this.patientChat aggiornabile
      *  tramite this.route.params.subscribe(..) però si sono manifestati diversi errori anomali. */
      const patientSSN = window.location.href.split('/')[4];
      let pc = null;
      if (patientSSN !== undefined) {
        pc = this.patients.find(p => p.ssn === patientSSN);
      } else {
        pc = undefined;
      }
      if (pc !== undefined && pc !== null) {
        // controllo se nei lastmessage appena aggiornati c'è un messaggio non letto e fa parte di questa chat.
        lastMessages.forEach(m => {
          if (m.patientEmail === pc.email && m.read === false && m.sender === m.patientEmail) {
            this.getChatMessages(pc);
            this.openSnackBar('Arrivato nuovo messaggio', '');
          }
        });
      }
    }));
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  ngOnDestroy() {
    this.subscripitons.forEach(sub => sub.unsubscribe());
    this.unsubscribeResizeChanges();
  }

  // Funzione per inviare un file al server.
  attachFile() {
    //Annullo il refresh nel caso si cambi finestra, perché in alcuni browser al ritorno dal caricamento
    //dell'allegato, veniva scatenato l'aggiornamento pagina e si chiudeva la dialog senza poter mandare il file.
    this.unsubscribeAppStateChange();
    // Per prima cosa si apre la dialog che permette di selezionarlo.
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      width: '400px',
    });
    // Una volta selezionato, dopo la chiusura della dialog ricevo il file. Se il file è undefined vuol dire che è stato
    // cliccato sul bottone annulla.
    dialogRef.afterClosed().subscribe(file => {
      if(file !== undefined){
        this.doctorService.sendFile(file, this.patientChat.email).subscribe(newMessage => {
          // l'end point contattato mi restituisce il dto con tutte le informazioni sul messaggio.
          // Aggiungo il messaggio tra quelli della finestra e pulisco il campo dove ho scritto il messaggio.
          this.messages.push(newMessage);
          this.scrollToBottom();
        }, error => {
        if (error.status === 500) {
          // In questo caso è molto più problema che l'errore 500 sia stato rilanciato perché il file è troppo grande.
          //localStorage.setItem('expirationTime', '0');
          //console.log('sessione scaduta');
          //location.reload();
          this.openErrorDialog('L\'allegato supera la dimensione massima accettata (15MB).');
        }
      });
      }
      //ristabilisco l'aggiornamento della pagina nel caso si cambi finestra.
      this.subscribeAppStateChange();
    });
  }

  // metodo che permette di scaricare il file appena cliccato.
  downloadFile(mess: ChatMessage) {
    this.doctorService.getFile(mess.patientEmail, mess.id).subscribe(data => {
      this.saveFile(data, mess.text);
      // apriamo il file in un altra finestra con le seguenti istruzioni.
      /*var fileURL = window.URL.createObjectURL(data);
      let tab = window.open();
      tab.location.href = fileURL;*/
    });
  }

  /* Questo metodo permette di iscriversi a un evento che si scatena quando la pagina viene modificata.
  *  Se quindi la pagina diventa troppo piccola viene settato un flag isMobile che ci permette di capire se siamo
  *  su un dispositivo mobile.*/
  subscribeResizeChanges(){
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      if (window.innerWidth < 600) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  unsubscribeResizeChanges(){
    this.resizeSubscription$.unsubscribe();
  }

  subscribeAppStateChange(){
    this.platform.ready().then(() => {
      App.addListener('appStateChange', (state: AppState) => {
        if (state.isActive) {
          console.log('App has become active');
          location.reload();
        }
      });
    })
  }

  unsubscribeAppStateChange(){
    this.platform.ready().then(() => {
      App.removeAllListeners();
    });
  }

  /* permette di scaricare il file */
  saveFile(blob, fileName){
    const a = document.createElement("a");
    document.body.appendChild(a);
    // @ts-ignore
    a.style = "display: none";
    //var json = JSON.stringify(data),
    //blob = new Blob([json], {type: "octet/stream"}),
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
